








































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import XSolid from '~/components/icons/XSolid.vue';
import CameraPlusOutline from '~/components/icons/CameraPlusOutline.vue';
import FileInput from '~/components/inputs/FileInput.vue';

@Component({
  components: { XSolid, CameraPlusOutline, FileInput },
})
export default class ProfileRunEditPhotos extends Vue {
  @Prop(Array) pictures: () => [];
  @Prop(Boolean) preventUploadCall: false;

  /*
    Everytime the user uploads a picture, it is emit to the parent to be
    handled
  */
  @Emit('upload-picture')
  emitPicture (val: string | File) {
    return val;
  }
}
